import Checkin from "@/components/Checkin";
import { ReadDialog } from "@/components/ReadDialog";
import { Button } from "@/components/ui/button";
import { useDailyCheckinContext } from "@/contexts/dailyCheckin";
import { useNavigationContext } from "@/contexts/navigation";
import { useStatsContext } from "@/contexts/stats";
import { supabase } from "@/lib/supabase/client";
import { useEffect, useState } from "react";


export default function CheckinSection() {
    const [text, setText] = useState<string>("Loading text...");

    const { balanceSectionRef } = useNavigationContext();

    const { evening, morning } = useDailyCheckinContext();

    const morningRatings = morning.ratings;
    const eveningRatings = evening.ratings;

    const { setStats } = useStatsContext();
    useEffect(() => {
        const morningTotal = morningRatings?.reduce((sum, rating) => sum + rating.rating, 0);
        const eveningTotal = eveningRatings?.reduce((sum, rating) => sum + rating.rating, 0);
        const avg = (morningTotal + eveningTotal) / ((morningRatings?.length ?? 0) + (eveningRatings?.length ?? 0));
        if (!avg) return;
        setStats(prev => ({ ...prev, averageCheckinScore: avg }));
    }, [eveningRatings, morningRatings, setStats]);

    useEffect(() => {
        (async () => {
            const { data, error } = await supabase.from("balance_text").select("text");
            if (error) {
                console.error(error);
                return;
            }
            setText(data[0].text);
        })();
    }, []);

    return (
        <section ref={balanceSectionRef} className="mx-auto flex flex-col items-center py-16 pb-12">
            <h2 className="text-3xl font-bold mb-4 text-foreground">
                Skatta din balans
            </h2>
            <p className="px-6 mb-6 text-center text-xl text-muted-foreground max-w-2xl mx-auto">
                Hur är ditt mentala, emotionella och fysiska läge just nu?<br />
                Utgå från känsla, inte prestation.
            </p>
            <ReadDialog
                textColor={"text-primary"}
                text={text}
                trigger={<Button variant="default">Läs om Balans och Kontroll</Button>}
                suppressProviderWarnings={true}
            />
            <div className="flex flex-row justify-center flex-wrap">
                <Checkin
                    onOpenChanged={morning.setOpen}
                    isOpen={morning.isOpen}
                    ref={morning.ref}
                    // buttonText="Morgon"
                    timeOfDay="morning"
                    onRatingsChanged={morning.setRatings}
                    // meditationButtonText="Meditation"
                    // meditationAudioTitle="Meditation - Morgon"
                    // meditationAudioUrl="https://lmwvrcrdcptbpvotelvu.supabase.co/storage/v1/object/sign/audio%20files/KONSTEN_GoodMorning_MEDITATION.wav?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV81YmE4YmZlYy0wOTI0LTQ0YjctYmUzZi1kOTc0ZWYwYzk3NDciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyBmaWxlcy9LT05TVEVOX0dvb2RNb3JuaW5nX01FRElUQVRJT04ud2F2IiwiaWF0IjoxNzY0MTUwOTk2LCJleHAiOjMzMjY4NjE0OTk2fQ.iJMbchbiluPB8pB4F17jV7g7FRyxzccSkUvekeF1JO8" // To add
                />
                {/* <Checkin
                    onOpenChanged={evening.setOpen}
                    isOpen={evening.isOpen}
                    ref={evening.ref}
                    buttonText="Kväll"
                    timeOfDay="evening"
                    onRatingsChanged={evening.setRatings}
                    meditationButtonText="Meditation"
                    meditationAudioTitle="Meditation - Kväll"
                    meditationAudioUrl="https://lmwvrcrdcptbpvotelvu.supabase.co/storage/v1/object/sign/audio%20files/KONSTEN_GoodNight_MEDITATION.wav?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV81YmE4YmZlYy0wOTI0LTQ0YjctYmUzZi1kOTc0ZWYwYzk3NDciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyBmaWxlcy9LT05TVEVOX0dvb2ROaWdodF9NRURJVEFUSU9OLndhdiIsImlhdCI6MTc2NDE1MTAxNCwiZXhwIjozMzI2ODYxNTAxNH0.wXGkr2NGwid1HuZQ_q08hqiCaDzP2al4yhGJl2YAXnc" // To add
                /> */}
            </div>
        </section>
    );
}